<app-web-loader *ngIf="isLoader"></app-web-loader>

<div id="login-inner-container">
    <div class="login-logo-div">
        <img src="assets/images/logo.png" alt=""/>
    </div>
    <a href="javascript:;" (click)="OpenHelpModel()" class="help-icon">
        <i class="fa fa-question-circle"></i>
    </a>

    <div class="login-bottom-div">

        <div class="login-form-div" *ngIf="!isForgotPIN">
            <form autocomplete="off" style="overflow: auto;" method="post" (ngSubmit)="doUserLogin()" [formGroup]="userForm">
                <div class="form-group">
                    <label for="userName" class="login-lable">Enter Mobile No <span
                            style="color:#18aa87;">(Whatsapp)</span></label>
                    <input type="text" class="form-control" formControlName="userName" maxlength="10"
                        placeholder="10-digit Mobile Number without +91" style="text-align: center;"
                        autocomplete="off" />
                    <div *ngIf="userForm.get('userName').hasError('pattern')" style="color: red;">
                        Please enter a valid 10-digit number.
                    </div>
                </div>
                <div class="form-group" *ngIf="isOTP">
                    <label for="userotp" class="login-lable">Enter OTP</label>
                    <input type="text" placeholder="Enter OTP" class="form-control text-center" id="userotp"
                        [(ngModel)]="userotp" [ngModelOptions]="{standalone: true}" autocomplete="off" />
                </div>
                <div class="form-group" *ngIf="isPIN">
                    <label for="userotp" class="login-lable">Enter PIN</label>
                    <input type="text" placeholder="Enter PIN" class="form-control text-center" id="userPIN"
                        [(ngModel)]="userPIN" [ngModelOptions]="{standalone: true}" autocomplete="off" />
                </div>
                <div class="form-group" *ngIf="isLoginWithOtp">
                    <label for="userotp" class="login-lable">Enter OTP</label>
                    <input type="text" placeholder="Enter OTP" class="form-control text-center" id="userotp"
                        [(ngModel)]="userotp" [ngModelOptions]="{standalone: true}" autocomplete="off" />
                </div>

                <div class="form-group" *ngIf="isUserPin">
                    <label for="userotp" class="login-lable" style="color: red;">Create PIN for Login</label>
                    <div class="otp-entry-div">
                        <div class="form-group text-center">
                            <span *ngFor="let pinNum of enteredPin" class="span-otp-text">{{ pinNum }}</span>
                        </div>
                    </div>
                    <div class="otp-keypad-div">
                        <div class="otp-keypad-inner-div">
                            <span class="span-keypad-text" (click)="AddPINintoArray('1')">1</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('2')">2</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('3')">3</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('B')">
                                <i class="fa fa-backspace"></i>
                            </span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('4')">4</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('5')">5</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('6')">6</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('C')">C</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('7')">7</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('8')">8</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('9')">9</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('0')">0</span>
                        </div>
                    </div>
                </div>

                <div class="form-group login-buttons-div">
                    <input type="submit" class="btn btn-login w-100 mt-2 mb-2" value="Continue" />

                    <!-- Resend OTP button as a button -->
                    <div *ngIf="isOTP">
                        <input type="button" *ngIf="isOTP" (click)="SendOTPSMS(true)"
                            style="width: 150px; margin: 0px auto;" class="btn btn-link" value="Resend OTP" />
                    </div>
                    <div *ngIf="isOTP == false">
                        <button type="button" *ngIf="isOTP == false ? isPIN : isOTP" class="btn btn-link w-45"
                            (click)="ForgotPassword()">Forgot PIN</button>
                        <button type="button" *ngIf="isOTP == false ? isPIN : isOTP"
                            class="btn btn-link w-45 font-weight-bold w-100" (click)="doLoginWithOTP()">Login With
                            OTP</button>
                    </div>
                    <button type="button" *ngIf="isLoginWithOtp" style="margin-top: 10px;" class="btn btn-link w-45"
                        (click)="ResetToLogin()">Clear All</button>
                    <!-- Spacer -->
                    <div style="margin-bottom: 10px;"></div>

                    <!-- Watch Help Video button with modal trigger -->
                    <a href="javascript:;" class="btn btn-watch-video" (click)="OpenHelpModel()">
                        <i class="fab fa-youtube"></i> Watch Help Video
                    </a>
                </div>


            </form>
        </div>

        <div class="login-form-div" *ngIf="isForgotPIN">

            <form autocomplete="off" method="post" (ngSubmit)="doChangeUserPassword()">
                <div class="form-group">
                    <label for="userName" class="login-lable">Enter Mobile No <span
                            style="color:#17a987;">(Whatsapp)</span></label>
                    <input type="text" [disabled]="isForgotPIN" class="form-control" id="userName"
                        [(ngModel)]="userName" [ngModelOptions]="{standalone: true}"
                        placeholder="India (+91) Your Phone Number" style="text-align: center;"
                        autocomplete="off" />
                </div>
                <div class="form-group">
                    <label for="userotp" class="login-lable">Enter OTP</label>
                    <input type="text" placeholder="Enter OTP" class="form-control text-center" id="userotp"
                        [(ngModel)]="userotp" [ngModelOptions]="{standalone: true}" autocomplete="off" />
                </div>

                <div class="form-group" *ngIf="isUserPin">
                    <label for="userotp" class="login-lable">Setup PIN for BuyRentSale Login</label>
                    <div class="otp-entry-div">
                        <div class="form-group text-center">
                            <span *ngFor="let pinNum of enteredPin" class="span-otp-text">{{ pinNum }}</span>
                        </div>
                    </div>
                    <div class="otp-keypad-div">
                        <div class="otp-keypad-inner-div">
                            <span class="span-keypad-text" (click)="AddPINintoArray('1')">1</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('2')">2</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('3')">3</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('B')">
                                <i class="fa fa-backspace"></i>
                            </span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('4')">4</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('5')">5</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('6')">6</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('C')">C</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('7')">7</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('8')">8</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('9')">9</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('0')">0</span>
                        </div>
                    </div>
                </div>

                <input type="submit" class="btn btn-login w-100" value="Continue" />
                <!-- Resend OTP button as a button -->
                <button type="button" [disabled]="isButtonClicked" *ngIf="!isUserPin" style="margin-top: 10px;"
                    class="btn btn-link w-45" (click)="ForgotPassword()">Resend OTP</button>

                <!-- Go To Login button as a button -->
                <button type="button" *ngIf="!isUserPin" class="btn btn-link w-45" (click)="ResetToLogin()">Go To
                    Login</button>
            </form>

        </div>

    </div>
</div>

<div class="modal fade" id="UserAlreadyExitsModal" tabindex="3" role="dialog"
    aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="confirm-user-div">
                <h5 class="text-center" *ngIf="UserData.length !== 0">
                    With this number, an account already exists as
                    <span [ngStyle]="{'color': UserData[0].UserType == 0 ? 'red' : 'blue'}">
                        {{ UserData[0].UserType == 0 ? 'Customer' : 'Agent' }}
                    </span>.
                    Do you want to continue as
                    <span [ngStyle]="{'color': userTypeID == 0 ? 'green' : 'red'}">
                        {{ userTypeID == 0 ? 'Customer' : 'Agent' }}
                    </span>?
                </h5>
                <div class="form-group text-center">
                    <input type="button" style="margin-right: 10px;" class="btn btn-danger" value="No"
                        (click)="doGotoLandingPage()" />
                    <input type="button" class="btn btn-success" value="Yes" (click)="SendOTPByMobile()"
                        [disabled]="isButtonClicked" />
                </div>

            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="ConfirmModal" tabindex="2" role="dialog"
    aria-labelledby="mySmallModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-sm">
        <div class="modal-content" style="padding: 20px;">
            <h3 class="gen_txt">The entered mobile number is not registered. Do you want to create new account ?</h3>
            <br />
            <div class="row pad10T">
                <div class="col-6">
                    <button (click)="gotoHomePage()" class="btn btn-danger pull-right">No</button>
                </div>
                <div class="col-6">
                    <button (click)="SendOTPByMobile()" class="btn btn-success">Yes</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="helpModal" tabindex="-1" role="dialog" 
    aria-labelledby="mySmallModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="helpModalLabel">Help and Support</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <!-- Add your support information here -->
                <p>For assistance, please contact:</p>
                <p class="contact">Email: <strong>support&#64;buyrentsale.com</strong></p>
                <p class="contact">Phone: <strong>91-9618641100</strong></p>

                <!-- Add a sample YouTube video link -->
                <p>For video assistance, you can watch this tutorial:</p>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/ynnCXJTpklk?si=UflK7z3suTzCwXsS"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>